import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import Vue from "vue";

let cancel;
const CancelToken = axios.CancelToken;

const cancelRequest = function() {
  if (cancel != undefined) {
    cancel("cancel");
  }
};

const cancelTokenConfig = function() {
  return new CancelToken(function executor(c) {
    cancel = c;
  });
};

const fetchOperations = function(
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search,
  tab
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios
    .post(
      pathConstants.API + `/operations/lookup?tab=${tab}`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(res => res.data)
    .catch(err => {
      Vue.$log.error("fetchOperations", err);
      return { content: [], totalElements: 0 };
    });
};
const fetchOperationsAgence = function(
  agenceId,
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search,
  tab
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios
    .post(
      pathConstants.API + `/operations/agences/${agenceId}?tab=${tab}`,
      { myPager: pager, customFilter, search },
      { cancelToken: cancelTokenConfig() }
    )
    .then(res => res.data)
    .catch(err => {
      Vue.$log.error("fetchOperationsAgence", err);
      return { content: [], totalElements: 0 };
    });
};
const downloadOperations = function(
  currentPage,
  perPage,
  sortBy,
  sortDir,
  customFilter,
  search,
  tab
) {
  const pager = {
    page: currentPage > 1 ? currentPage - 1 : 0,
    size: perPage,
    defaultSort: sortBy,
    defaultOrder: sortDir
  };
  cancelRequest();
  return axios({
    url: pathConstants.API + `/operations/downloadOperations?tab=${tab}`,
    method: "POST",
    data: { customFilter, search },
    responseType: "blob",
    showLoader: false
  })
    .then(response => {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"]
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "operations.xlsx";
      link.click();
      window.URL.revokeObjectURL(link.href);
    })
    .catch(error => {
      Vue.$log.error("downloadOperations", error);
    });
};
const getDetailOperationById = function(id) {
  return axios
    .get(pathConstants.API + `/operations/operation-detail/${id}`, {
      showLoader: false
    })
    .then(res => res.data)
    .catch(err => {
      Vue.$log.error("getDetailOperationById", err);
      return null;
    });
};
const getOperationHistoryById = function(id) {
  return axios
    .get(pathConstants.API + `/operations/operationHistory/${id}`, {
      showLoader: false
    })
    .then(res => res.data)
    .catch(err => {
      Vue.$log.error("getOperationHistoryById", err);
      return [];
    });
};
const getOperationDocumentsById = function(id) {
  return axios
    .get(`${pathConstants.API}/operations/operationDocument/${id}`, {
      showLoader: false
    })
    .then(res => res.data)
    .catch(err => {
      Vue.$log.error("fetchDocumentsByOperation", err);
      return [];
    });
};

export const operationService = {
  fetchOperations,
  fetchOperationsAgence,
  downloadOperations,
  getDetailOperationById,
  getOperationHistoryById,
  getOperationDocumentsById
};
